export default{
    __bsi_SeeAll:"로그인하여 모두 보기",
    __asi_SeeAll:"모두 보기",
    __CasinoSectionTitle: "라이브 카지노"
}